/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { publishEvent } from "../../funcs/publishEvent.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.PublishRequest$inboundSchema,
};

export const tool$publishEvent: ToolDefinition<typeof args> = {
  name: "publish-event",
  description: `Publish Event

Publishes an event to the specified topic, potentially routed to a specific destination. Requires Admin API Key.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await publishEvent(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
